import { InternationalAddress } from '../models/international-address.model';

/**
 * Lenient "same physical place" equality key: lowercase, strip punctuation, collapse
 * whitespace, compare postal on the first 5 digits — and IGNORE country entirely.
 * Country is deliberately excluded because stored values are inconsistent
 * (DEFAULT_COUNTRY is "U.S.", live forms write "US", legacy docs hold '') and it never
 * distinguishes two buildings of one customer, which is what this key exists to do.
 */
export function normalizeAddressKey(a: InternationalAddress | null | undefined): string {
    const n = (s?: string) => (s ?? '').toLowerCase().replace(/[.,#]/g, ' ').replace(/\s+/g, ' ').trim();
    return [n(a?.line1), n(a?.line2), n(a?.city), n(a?.region), n(a?.postalCode).slice(0, 5)].join('|');
}

/**
 * City-block-level key: same city/state/zip but line1/line2 free to differ. Used to
 * catch the "two buildings across the street" case (and a parse that dropped the
 * building line) so the UI can force an explicit choice instead of preselecting.
 */
export function looseAddressKey(a: InternationalAddress | null | undefined): string {
    const n = (s?: string) => (s ?? '').toLowerCase().replace(/\s+/g, ' ').trim();
    return [n(a?.city), n(a?.region), n(a?.postalCode).slice(0, 5)].join('|');
}
